export const TABINDEX = 0;
export const RENDERED_CLASS = 'rendered';
